import React, { Component } from 'react';
import hsLogo from '../../hubspot.png';
import styles from '../ConnectPage/styles.css';

class InstructionPage extends Component {
  render() {

    const href = `/auth/hubspot/integration`;
    const props = {
      href,
      className: `btn btn-default btn-lg btn-block ${styles.btnHubspot}`,
    };

    return (
      <div style={{ margin: 'auto', padding: '50px' }} className="text-center">
        <p>
          Since you are an integrate user, you need to authorize TruSales for sync permissions.<br />
          Click the button below to continue.
        </p>
        <a {...props}>
          <img width="120" alt="HubSpot" src={hsLogo} role="presentation" />
        </a>
      </div>
    );
  }
}

InstructionPage.propTypes = {
};

InstructionPage.defaultProps = {
};

InstructionPage.contextTypes = {
};

export default InstructionPage;
